import {call, put, takeLatest, takeEvery} from "redux-saga/effects";
import {
  apiGetScreeningOneTest,
  apiGetScreeningTestsList,
  apiPostScreeningOneTest,
  apiGetScreeningEarlyTestsList,
  apiPostScreeningOneEarlyTest,
  apiGetScreeningRotinesTest,
  apiPostScreeningEarlyQuestionsList
} from "./api";
import {
  fetchScreeningOneTestAction,
  fetchScreeningOneTestActionDone,
  fetchScreeningOneTestActionFail,
  fetchScreeningTestsListAction,
  fetchScreeningEarlyTestsListAction,
  
  fetchScreeningTestsListActionDone,
  fetchScreeningTestsListActionFail, postScreeningEarlyQuestionsListAction,
  postScreeningEarlyQuestionsListActionDone,
  postScreeningEarlyQuestionsListActionFail,
  fetchScreeningEarlyTestsListActionDone ,
  postScreeningOneTestAction,
  postScreeningOneEarlyTestAction,
  postScreeningOneTestActionDone,
  postScreeningOneEarlyTestActionDone,
  fetchScreeningEarlyTestsListActionFail,
  postScreeningOneTestActionFail,
  postScreeningOneEarlyTestActionFail,
  setOneTestAction,
  setOneEarlyTestAction,
  fetchScreeningRoutinesListActionFail,
  fetchScreeningRoutinesListActionDone,
  fetchScreeningRoutinesListAction,
} from "./actions";
import {PayloadAction} from "@reduxjs/toolkit";


function* testListFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiGetScreeningTestsList, payload)
    if (data) {
      const formattedData = data.map((dataItem:any) => ({
        ...dataItem,
        status: false,
        recommendations: undefined,
        score: null
      }))

      yield put(fetchScreeningTestsListActionDone(formattedData))
    }

  } catch (e) {
    yield put(fetchScreeningTestsListActionFail())
  }
}

function* testEarlyListFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiGetScreeningEarlyTestsList, payload)
    if (data) {
      const formattedData = data.map((dataItem:any) => ({
        ...dataItem,
        status: false,
        recommendations: undefined,
        score: null
      }))

      yield put(fetchScreeningEarlyTestsListActionDone (formattedData))
    }

  } catch (e) {
    yield put(fetchScreeningEarlyTestsListActionFail())
  }
}

function* oneTestFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiGetScreeningOneTest, payload)
    if (data) {
      yield put(fetchScreeningOneTestActionDone(data))
    }

  } catch (e) {
    yield put(fetchScreeningOneTestActionFail())
  }
}

function* surveysTestFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiGetScreeningRotinesTest, payload)
    if (data) {
      yield put(fetchScreeningRoutinesListActionDone(data))
    }

  } catch (e) {
      yield put(fetchScreeningRoutinesListActionDone({
        "surveys": [
          {
            "id": 10,
            "name": "ДОСУГ / КНИГИ / ТВ",
            "description": "Описание досуга, книг и телевизионных программ",
            "count": 2
          },
          {
            "id": 2,
            "name": "КАК РЕБЕНОК СПИТ ДНЕМ",
            "description": "Описание дневного сна ребенка",
            "count": 1
          },
          {
            "id": 3,
            "name": "КАК РЕБЕНОК ГОТОВИТСЯ К НОЧНОМУ СНУ, СПИТ НОЧЬЮ",
            "description": "Описание подготовки ко сну и ночного сна ребенка",
            "count": 2
          },
          {
            "id": 8,
            "name": "ВРЕМЯ, КОГДА ИГРАЕТ ОДИН",
            "description": "Описание времени, когда ребенок играет один",
            "count": 3
          },
          {
            "id": 6,
            "name": "ТУАЛЕТ / СМЕНА ПОДГУЗНИКА",
            "description": "Описание процесса туалета и смены подгузника",
            "count": 1
          },
          {
            "id": 7,
            "name": "ИГРА С ДРУГИМИ ЛЮДЬМИ / ДЕТЬМИ",
            "description": "Описание игры с другими людьми или детьми",
            "count": 3
          },
          {
            "id": 9,
            "name": "КУПАНИЕ / УМЫВАНИЕ",
            "description": "Описание процесса купания и умывания ребенка",
            "count": 3
          },
          {
            "id": 1,
            "name": "КАК РЕБЕНОК ПРОСЫПАЕТСЯ",
            "description": "Описание пробуждения ребенка",
            "count": 2
          },
          {
            "id": 5,
            "name": "ОДЕВАНИЕ",
            "description": "Описание процесса одевания ребенка",
            "count": 2
          },
          {
            "id": 4,
            "name": "ПРИЕМ ПИЩИ",
            "description": "Описание процесса приема пищи ребенка",
            "count": 4
          }
        ]
      }))
    // yield put(fetchScreeningRoutinesListActionFail())
  }
}

function* postOneTestFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiPostScreeningOneTest, payload)
    if (data) {
      yield put(postScreeningOneTestActionDone(data))
      yield put(setOneTestAction({...data, id: payload.test_id}))
      payload.onSuccess();
    }

  } catch (e) {
    yield put(postScreeningOneTestActionFail())
  }
}

function* postOneEarlyTestFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiPostScreeningOneEarlyTest, payload)
    if (data) {
      yield put(postScreeningOneEarlyTestActionDone(data))
      yield put(setOneEarlyTestAction({...data, id: payload.user_test_id}))
      payload.onSuccess();
    }

  } catch (e) {
    yield put(postScreeningOneEarlyTestActionFail())
  }
}

function* postScreeningEarlyQuestionListFlow({payload}:PayloadAction<any>): any {
  try {
    const data = yield call(apiPostScreeningEarlyQuestionsList, payload)
    if (data) {
      yield put(postScreeningEarlyQuestionsListActionDone(data))
    }

  } catch (e) {
    // postScreeningEarlyQuestionsListActionFail
    yield put(postScreeningEarlyQuestionsListActionDone(
      [
        {
          "id": 173,
          "survey_id": 8,
          "text": "Захватывает свою ногу и тянет ее в рот",
          "min_age": 4,
          "max_age": 6,
          "icf_domain": [
            "D1",
            "D4"
          ],
          "answers": [
            {
              "id": 1,
              "text": "Еще не делает"
            },
            {
              "id": 2,
              "text": "Редко"
            },
            {
              "id": 3,
              "text": "Часто"
            },
            {
              "id": 5,
              "text": "Уже не делает"
            }
          ]
        },
        {
          "id": 25,
          "survey_id": 2,
          "text": "Смотрит/слушает повторяющиеся движения/звуки, чтобы заснуть",
          "min_age": 4,
          "max_age": 6,
          "icf_domain": [
            "D2"
          ],
          "answers": [
            {
              "id": 1,
              "text": "Еще не делает"
            },
            {
              "id": 2,
              "text": "Редко"
            },
            {
              "id": 3,
              "text": "Часто"
            },
            {
              "id": 5,
              "text": "Уже не делает"
            }
          ]
        },
        {
          "id": 172,
          "survey_id": 8,
          "text": "Исследует предметы руками и ртом",
          "min_age": 4,
          "max_age": 6,
          "icf_domain": [
            "D1"
          ],
          "answers": [
            {
              "id": 1,
              "text": "Еще не делает"
            },
            {
              "id": 2,
              "text": "Редко"
            },
            {
              "id": 3,
              "text": "Часто"
            },
            {
              "id": 5,
              "text": "Уже не делает"
            }
          ]
        },
        {
          "id": 174,
          "survey_id": 8,
          "text": "Самостоятельно берет игрушки руками",
          "min_age": 5,
          "max_age": 6,
          "icf_domain": [
            "D1",
            "D4"
          ],
          "answers": [
            {
              "id": 1,
              "text": "Еще не делает"
            },
            {
              "id": 2,
              "text": "Редко"
            },
            {
              "id": 3,
              "text": "Часто"
            },
            {
              "id": 5,
              "text": "Уже не делает"
            }
          ]
        },
        {
          "id": 137,
          "survey_id": 7,
          "text": "Смотрит на человека и вокализирует в ответ на свое имя",
          "min_age": 5,
          "max_age": 6,
          "icf_domain": [
            "D3"
          ],
          "answers": [
            {
              "id": 1,
              "text": "Еще не делает"
            },
            {
              "id": 2,
              "text": "Редко"
            },
            {
              "id": 3,
              "text": "Часто"
            },
            {
              "id": 5,
              "text": "Уже не делает"
            }
          ]
        },
        {
          "id": 139,
          "survey_id": 7,
          "text": "Играет с другими людьми без суеты и расстройства",
          "min_age": 6,
          "max_age": 7,
          "icf_domain": [
            "D2"
          ],
          "answers": [
            {
              "id": 1,
              "text": "Еще не делает"
            },
            {
              "id": 2,
              "text": "Редко"
            },
            {
              "id": 3,
              "text": "Часто"
            },
            {
              "id": 5,
              "text": "Уже не делает"
            }
          ]
        },
        {
          "id": 138,
          "survey_id": 7,
          "text": "Участвует в простых играх с взрослым или старшими детьми, например ку-ку",
          "min_age": 6,
          "max_age": 7,
          "icf_domain": [
            "D9"
          ],
          "answers": [
            {
              "id": 1,
              "text": "Еще не делает"
            },
            {
              "id": 2,
              "text": "Редко"
            },
            {
              "id": 3,
              "text": "Часто"
            },
            {
              "id": 5,
              "text": "Уже не делает"
            }
          ]
        }
      ]
    ))
  }
}

export default function* screeningSaga() {
  yield takeLatest(fetchScreeningTestsListAction,testListFlow)
  yield takeLatest(fetchScreeningEarlyTestsListAction,testEarlyListFlow)
  yield takeLatest(fetchScreeningOneTestAction,oneTestFlow)
  yield takeLatest(postScreeningOneTestAction,postOneTestFlow)
  yield takeLatest(postScreeningOneEarlyTestAction,postOneEarlyTestFlow)
  yield takeLatest(fetchScreeningRoutinesListAction,surveysTestFlow)
  yield takeEvery(postScreeningEarlyQuestionsListAction,postScreeningEarlyQuestionListFlow)
}